module.exports = __webpack_public_path__ + "static/budgetIcon-f70d8ee48862223929164e5fd9890e71.png";